import React from 'react';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import faq from '../data/Faq.json';

function Faq() {
  return (
    <Container
      maxWidth='lg'
      sx={{ pt: { xs: 4, md: 7 }, '& .MuiTypography-root': { overflowWrap: 'anywhere' } }}
    >
      <Box sx={{ maxWidth: 780, mb: 5 }}>
        <Typography
          component='h1'
          variant='h3'
          sx={{ fontWeight: 800, color: '#0B2545', fontSize: { xs: '2rem', md: '3rem' } }}
        >
          Frequently asked questions
        </Typography>
        <Typography
          variant='body1'
          sx={{ mt: 2, color: '#475569' }}
        >
          Answers to the questions teams usually ask before getting in touch: how work starts,
          pricing, platforms, who does the work, and accessibility.
        </Typography>
      </Box>

      <Box sx={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)', gap: 4, maxWidth: 780 }}>
        {faq.items.map((item) => (
          <Box
            component='section'
            key={item.id}
            aria-labelledby={`faq-${item.id}`}
          >
            <Typography
              component='h2'
              id={`faq-${item.id}`}
              variant='h5'
              sx={{ mb: 1, fontWeight: 700, color: '#0B2545' }}
            >
              {item.question}
            </Typography>
            <Typography
              variant='body1'
              sx={{ color: '#475569', maxWidth: '72ch' }}
            >
              {item.answer}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box
        component='section'
        aria-labelledby='faq-next-steps'
        sx={{
          mt: 6,
          p: { xs: 3, md: 4 },
          maxWidth: 780,
          borderRadius: 2,
          bgcolor: '#EFF6FC',
          borderLeft: '4px solid #005596',
        }}
      >
        <Typography
          component='h2'
          id='faq-next-steps'
          variant='h6'
          sx={{ mb: 2, fontWeight: 700, color: '#0B2545' }}
        >
          Next steps
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          <Button
            component={Link}
            to='/contact-us?subject=cms-workflow-assessment'
            data-track='assessment_request'
            variant='contained'
            endIcon={<ArrowForwardIcon />}
            sx={{
              backgroundColor: '#0B2545',
              color: '#FFFFFF',
              '&:hover': { backgroundColor: '#005596' },
            }}
          >
            Request a CMS &amp; workflow assessment
          </Button>
          <Button
            component={Link}
            to='/services#first-engagement'
            endIcon={<ArrowForwardIcon />}
          >
            See assessment details on Services
          </Button>
          <Button
            href='/cms-capabilities'
            data-track='capability_statement'
            endIcon={<ArrowForwardIcon />}
          >
            View CMS capability statement
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default Faq;
